/**
 * Fitnesspilot
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ScheduledMuscle interface.
 */
export function instanceOfScheduledMuscle(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "regenerationSlope" in value;
    return isInstance;
}
export function ScheduledMuscleFromJSON(json) {
    return ScheduledMuscleFromJSONTyped(json, false);
}
export function ScheduledMuscleFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: json.id,
        regenerationSlope: json.regenerationSlope,
    };
}
export function ScheduledMuscleToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        regenerationSlope: value.regenerationSlope,
    };
}
